import { useSelector } from 'react-redux';

export function useCompanyUsage() {
    return useSelector(state => state.dataCollector?.companyUsage);
}

export function useCompanyUsageValueByProperty(property) {
    return useSelector(state => state.dataCollector?.companyUsage?.[property] || 0);
}
